interface ServiceIntroProps {
  onStart: () => void;
}

// 음성 파형: 서비스(음성 기반 인지건강)를 표현하는 Visual
const WAVEFORM_BARS = [14, 22, 34, 18, 42, 26, 44, 16, 30, 12];

// 서비스 소개 (스픽 스타일)
// - 개별 게임 설명이 아니라, 이 서비스가 무엇인지(음성 기반 인지건강 확인)를 가장 먼저 안내한다.
// - 흐름상 진입(entry) 화면으로, 이후 두뇌풀기 안내 → 게임 소개로 이어진다.
// - 로고는 페이지 최상단에 고정하고, 타이틀·설명·파형 Visual 만 세로 가운데에 배치한다.
export default function ServiceIntro({ onStart }: ServiceIntroProps) {
  return (
    <div className="flex flex-col h-full bg-white px-6 pt-[calc(16px+env(safe-area-inset-top))] animate-fade-in-up">
      {/* 로고: 페이지 최상단 고정 */}
      <div className="shrink-0 flex justify-center">
        <img
          src="https://storage.helloreaddy.io/project_files/a1e21e58-82d2-4e64-8a34-d104a4996fee/26afe99a-88fc-4cd8-9b48-938ec47e0bca_compressed_spick-health_b.webp"
          alt="스픽-헬스 로고"
          className="h-10 w-auto object-contain"
        />
      </div>

      {/* 중앙 콘텐츠: 타이틀 → 설명 → 파형 Visual 을 하나의 그룹으로 묶어 가운데 정렬 */}
      <div className="flex-1 min-h-0 overflow-y-auto flex flex-col">
        <div className="m-auto w-full flex flex-col items-center text-center">
          <h1 className="text-[26px] leading-snug font-bold text-foreground-950 tracking-tight">
            목소리로 간편하게 확인하는
            <br />
            나의 인지건강
          </h1>
          {/* 말풍선 + 음성 파형 */}
          <div className="relative mt-10">
            <div className="bg-primary-50 rounded-[28px] px-10 py-8 flex flex-col items-center">
              <div className="flex items-center justify-center gap-[3px] h-12">
                {WAVEFORM_BARS.map((h, i) => (
                  <span
                    key={i}
                    className="waveform-bar w-1.5 rounded-full bg-primary-500"
                    style={{ height: `${h}px`, animationDelay: `${i * 0.09}s` }}
                  />
                ))}
              </div>
            </div>
            <div className="absolute -bottom-2 left-12 w-5 h-5 bg-primary-50 rotate-45 rounded-sm" />
          </div>
        </div>
      </div>

      <div className="shrink-0 pt-4 pb-[calc(20px+env(safe-area-inset-bottom))]">
        {/* 의료적 안내: 경고가 아닌 보조정보로 표현 */}
        <div className="flex items-start gap-2.5 rounded-xl bg-primary-50 px-4 py-3.5 mb-4">
          <i className="ri-information-line text-[16px] text-primary-600 mt-[1px] leading-none" />
          <p className="text-[13px] leading-relaxed text-foreground-600">
            본 서비스는 인지건강 상태 확인을 위한 참고용 서비스이며, 의료적 진단이나
            의학적 소견을 제공하지 않습니다.
          </p>
        </div>

        <button
          onClick={onStart}
          className="w-full h-14 rounded-xl sh-cta text-white font-semibold text-base whitespace-nowrap
            active:scale-[0.99] transition-transform duration-150 cursor-pointer"
        >
          인지건강 체크하기
        </button>
      </div>
    </div>
  );
}